module.exports = __webpack_public_path__ + "static/media/sfx_animal_elephant.87d39796.mp3";